//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from "../components/BottomNav";
import emptyCell from "../components/emptyCell";
import util from '@/lib/util';

export default {
    name: "my-repairRecords",
    components: {
        emptyCell,
        BottomNav,
    },
    data() {
        return {
            memberId: 0,
            list: [],
            refreshing: false,
            pageIndex: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            downloadUrl: util.ApiUrl + '/file/download/',
            show: false,
            delId: 0,
            saving: false,
            active: 3,
            member: {}
        }
    },
    methods: {
        onRefresh() {
            this.pageIndex = 1;
            this.getRepairRecords();
        },
        onLoad() {
            this.pageIndex++;
            this.getRepairRecords()
        },
        getRepairRecords() {
            if (this.memberId > 0) {
                this.refreshing = this.pageIndex === 1;
                this.loading = this.pageIndex > 1;
                var page = {
                    memberId: this.memberId,
                    maxResultCount: this.pageSize,
                    workOrderType: 2,
                    skipCount: (this.pageIndex - 1) * this.pageSize
                };
                abp.ajax.post('/api/services/app/WorkOrder/MemberSearchWorkOrders', page).then((res) => {
                    if (this.pageIndex === 1) {
                        this.list = [];
                    }
                    this.list.push(...res.data.result.items);
                    // console.log(this.list);
                    if (res.data.result.items.length < this.pageSize) {
                        this.finished = true;
                    } else {
                        this.finished = false;
                    }
                }).then(() => {
                    this.refreshing = false;
                    this.loading = false;
                }).catch((error) => {
                    this.refreshing = false;
                    this.loading = true;
                }).finally(() => {
                    // this.refreshing = false;
                    // this.loading = true;
                });
            }

        },
        onConfirm() {
            this.onDelete();
        },
        onShowDialog(id) {
            this.delId = 0;
            this.delId = id;
            this.show = true;

        },
        onDelete() {
        },
        onCancelRepair(id) {
            var page = {
                id: 0,
                repairRecordId: id,
                repairOperatorType: 6,
                dealWithRemark: '业主微信服务号取消',
                file: {associateType: 'RepairInfoFile'}
            };

        },
        showRecordInfo(id) {
            this.$router.push({
                // name: 'repairRecordInfo',
                name: 'member-workSheetDetail',
                params: {
                    id: id
                }
            })
        },
        getMyMember() {
            const vm = this;
            this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.member = vm.$store.state.member.memberInfo;
                vm.memberId = vm.member.id;
                vm.onRefresh();
            }).finally(() => {
                vm.$toast.clear();
            });

        }
    },
    created() {
        this.getMyMember();
        // this.memberId = parseInt(this.$route.params.id) || 0;
        // if (this.memberId > 0) {
        //     this.onRefresh();
        // }
    }
}
